<div class="panel">
  <mat-button-toggle-group
    class="sub-tab-toggle"
    [value]="activeSubTab"
    (change)="onSubTabChanged($event.value)"
    aria-label="Filename conventions sub-tab"
  >
    <mat-button-toggle value="range">
      <mat-icon>format_list_numbered</mat-icon>
      Range
      <span class="sub-tab-count">· {{ rangeConventions.length }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="ev">
      <mat-icon>tune</mat-icon>
      EV
      <span class="sub-tab-count">· {{ evConventions.length }}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div class="sub-tab-header">
    @if (canWrite) {
      <button
        mat-icon-button
        color="buttonSuccess"
        [matTooltip]="activeSubTab === 'range' ? 'Create new Range filename convention' : 'Create new EV filename convention'"
        aria-label="Create filename convention"
        (click)="activeSubTab === 'range' ? onCreateRange() : onCreateEv()"
      >
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>

  @if (loaded) {
    @if (visibleConventions.length === 0) {
      <div class="empty-state">
        No {{ activeSubTab === 'range' ? 'Range' : 'EV' }} conventions yet. Click the
        + button to add one.
      </div>
    } @else {
      <div class="spec-list">
        @for (row of visibleConventions; track row.id) {
          <div class="spec-list-item">
            <div class="spec-info">
              <div class="spec-name-row">
                <span class="spec-name">{{ row.name }}</span>
                @if (activeSubTab === 'ev') {
                  <span class="range-meta">
                    <mat-icon class="mat-icon-inline">{{ metaIcon(row) }}</mat-icon>
                    {{ metaLabel(row) }}
                  </span>
                }
              </div>
              <div class="spec-summary-row">
                @if (activeSubTab === 'range') {
                  <span class="spec-kv">
                    <span class="k">Range entries</span>
                    <span class="v">{{ summary(row).entryCount }}</span>
                  </span>
                } @else {
                  <span class="spec-kv">
                    <span class="k">EVs configured</span>
                    <span class="v">{{ summary(row).entryCount }}</span>
                  </span>
                  <span class="spec-kv">
                    <span class="k">Master suites</span>
                    <span class="v">{{ masterSuiteLabel(summary(row).masterSuiteCount) }}</span>
                  </span>
                  <span class="spec-kv">
                    <span class="k">Select rows</span>
                    <span class="v">{{ summary(row).selectRowCount }}</span>
                  </span>
                }
              </div>
              @if (activeSubTab === 'range') {
                @let preview = rangePreview(row);
                @if (preview.length > 0) {
                  <div class="spec-preview-row">
                    <span class="preview-label">First entry</span>
                    <span class="preview-value">
                      @for (chip of preview; track trackTokenFormat($index, chip)) {
                        @if (classifyChip(chip.value) === 'token') {
                          <span class="tok">{{ chipLabelOf(chip.value) }}</span>
                        } @else {
                          <span class="lit">{{ chip.value }}</span>
                        }
                      }
                    </span>
                    <span class="spec-kv casing-inline">
                      <span class="k">Casing</span>
                      <span class="v">{{ firstEntryCasing(row) }}</span>
                    </span>
                  </div>
                }
              }
            </div>
            <div class="row-actions">
              @if (canAudit) {
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="View change history"
                  aria-label="View change history"
                  (click)="onViewConventionHistory(row)"
                >
                  <mat-icon>history</mat-icon>
                </button>
              }
              @if (canWrite) {
                <button
                  mat-icon-button
                  color="buttonSuccess"
                  matTooltip="Update"
                  aria-label="Update filename convention"
                  (click)="onUpdateConvention(row)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Delete"
                  aria-label="Delete filename convention"
                  (click)="onDeleteConvention(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
